(function() {
  'use strict';

  function getForm() {
    // Find parent .product container
    const productContainer = document.querySelector('.product');
    if (!productContainer) return null;

    // Find form with action="/cart/add"
    const form = productContainer.querySelector('form[action="/cart/add"]');
    return form;
  }

  function getSellingPlanInput() {
    const form = getForm();
    if (!form) return null;

    // Check if selling_plan input exists
    let sellingPlanInput = form.querySelector('input[name="selling_plan"]');

    // If doesn't exist, create it
    if (!sellingPlanInput) {
      sellingPlanInput = document.createElement('input');
      sellingPlanInput.type = 'hidden';
      sellingPlanInput.name = 'selling_plan';
      form.appendChild(sellingPlanInput);
    }

    return sellingPlanInput;
  }

  function getQuantityInput() {
    const form = getForm();
    if (!form) return null;

    // Check if quantity input exists
    let quantityInput = form.querySelector('input[name="quantity"]');

    // If doesn't exist, create it
    if (!quantityInput) {
      quantityInput = document.createElement('input');
      quantityInput.type = 'hidden';
      quantityInput.name = 'quantity';
      quantityInput.value = '1';
      form.appendChild(quantityInput);
    }

    return quantityInput;
  }

  function handleSubscription() {
    const subscriptionRadio = document.querySelector('#purchase_type_subscription');
    const sellingPlanId = subscriptionRadio?.dataset.sellingPlanId || '';

    // Set selling plan ID
    if (sellingPlanId) {
      const sellingPlanInput = getSellingPlanInput();
      if (sellingPlanInput) {
        sellingPlanInput.value = sellingPlanId;
      }
    }

    // Hide one-time elements
    const onetimeElements = document.querySelectorAll('[data-onetime-element]');
    onetimeElements.forEach(element => {
      element.classList.add('hidden');
    });

    // Show subscription elements (remove hidden class)
    const subsaveElements = document.querySelectorAll('[data-subsave-element]');
    subsaveElements.forEach(element => {
      element.classList.remove('hidden');
    });
  }

  function handleOneTime() {
    // Clear selling plan
    const sellingPlanInput = getSellingPlanInput();
    if (sellingPlanInput) {
      sellingPlanInput.value = '';
    }

    // Reset quantity to 1 when switching to one-time
    const quantityInput = getQuantityInput();
    if (quantityInput) {
      quantityInput.value = '1';
    }

    // Hide subscription elements
    const subsaveElements = document.querySelectorAll('[data-subsave-element]');
    subsaveElements.forEach(element => {
      element.classList.add('hidden');
    });

    // Show one-time elements (remove hidden class)
    const onetimeElements = document.querySelectorAll('[data-onetime-element]');
    onetimeElements.forEach(element => {
      element.classList.remove('hidden');
    });
  }

  function handleQuantityChange(quantityValue) {
    // Only update quantity if one-time is selected
    const onetimeRadio = document.querySelector('#purchase_type_onetime');
    if (!onetimeRadio || !onetimeRadio.checked) return;

    const quantityInput = getQuantityInput();
    if (quantityInput) {
      quantityInput.value = quantityValue || '1';
    }
  }

  function checkPurchaseType() {
    const subscriptionRadio = document.querySelector('#purchase_type_subscription');
    const onetimeRadio = document.querySelector('#purchase_type_onetime');

    if (subscriptionRadio && subscriptionRadio.checked) {
      handleSubscription();
    } else if (onetimeRadio && onetimeRadio.checked) {
      handleOneTime();
    }
  }

  function init() {
    const subscriptionRadio = document.querySelector('#purchase_type_subscription');
    const onetimeRadio = document.querySelector('#purchase_type_onetime');

    // Check initial state on load
    checkPurchaseType();

    // Listen for purchase type changes
    if (subscriptionRadio) {
      subscriptionRadio.addEventListener('change', function() {
        if (this.checked) {
          handleSubscription();
        }
      });
    }

    if (onetimeRadio) {
      onetimeRadio.addEventListener('change', function() {
        if (this.checked) {
          handleOneTime();
        }
      });
    }

    // Listen for quantity changes (one-time purchase)
    const quantityInputs = document.querySelectorAll('input[name="onetime_quantity"]');
    quantityInputs.forEach(input => {
      input.addEventListener('change', function() {
        handleQuantityChange(this.value);
      });
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
